export default __webpack_public_path__ + "static/media/740.cd3d16c7.gif";